import { render, staticRenderFns } from "./VipOrder.vue?vue&type=template&id=6e7a2d0e&scoped=true&"
import script from "./VipOrder.vue?vue&type=script&lang=js&"
export * from "./VipOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7a2d0e",
  null
  
)

export default component.exports